import { AddressModel } from './AddressFormConfig';

export type BaseUser = {
  email: string;
  firstName: string;
  lastName: string;
  sub: string;
};

export type User = BaseUser & {
  isAdministrator: boolean;
};

export enum UserAddressType {
  billing = 'billing',
  contact = 'contact',
}

export type UserDefaultAddress = AddressModel<'defaultContactAddress'>;
export type UserDefaultBillingAddress = AddressModel<'defaultBillingAddress'>;
export type UserProfileDefaultAddress = UserDefaultAddress & UserDefaultBillingAddress;

export type UserProfile = User &
  UserProfileDefaultAddress & {
    id: number;
    companyName: string;
    hasPassword: boolean;
    defaultGa4PropertyId: string;
    ga4ConnectionValid: boolean;
    ga4ConnectionCheckedAt: Date | null;
  };

export type GetUserProfileResponse = {
  user: UserProfile;
};

export type GetUsersListResponse = {
  users: UserProfile[];
};

export type UpdateUserProfileRequest = Omit<
  UserProfile,
  'id' | 'sub' | 'email' | 'firstName' | 'lastName' | 'companyName' | 'hasPassword'
>;
